module.exports = __webpack_public_path__ + "img/36.a86e1210.jpg";